<template>
    <button class="button button--flipped button--fullscreen" v-if="!onHomePage" :class="{ 'active': isFullscreen }"
        @click="toggleFullscreen" aria-hidden="true">
        <div class="icon"></div>
        <span>Full screen</span>
    </button>
</template>
<script>
export default {
    props: ["onHomePage"],
    methods: {
        toggleFullscreen() {
            app.api.Utils.toggleFullscreen();
        }
    },
    computed: {
        isFullscreen() {
            return this.$store.getters.isFullscreen
        }
    }
}
</script>
<style lang="scss" scoped>
.button {
    position: absolute;
    right: 50px;
    bottom: 50px;
}
</style>